/** Stroke icons, 24×24, inherit currentColor. */

import { SVGProps } from "react";

export type IconProps = SVGProps<SVGSVGElement> & { size?: number };

function Svg({ size = 16, children, ...rest }: IconProps & { children: React.ReactNode }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
      {...rest}
    >
      {children}
    </svg>
  );
}

export const Icons = {
  overview: (p: IconProps) => (
    <Svg {...p}><rect x="3" y="3" width="7" height="7" rx="1.5" /><rect x="14" y="3" width="7" height="7" rx="1.5" /><rect x="3" y="14" width="7" height="7" rx="1.5" /><rect x="14" y="14" width="7" height="7" rx="1.5" /></Svg>
  ),
  processes: (p: IconProps) => (
    <Svg {...p}><circle cx="6" cy="6" r="2.2" /><circle cx="18" cy="6" r="2.2" /><circle cx="12" cy="18" r="2.2" /><path d="M8 6h8M7.5 7.8 10.8 16M16.5 7.8 13.2 16" /></Svg>
  ),
  runs: (p: IconProps) => (
    <Svg {...p}><circle cx="12" cy="12" r="9" /><path d="M10 8.5v7l6-3.5-6-3.5z" /></Svg>
  ),
  events: (p: IconProps) => (
    <Svg {...p}><path d="M4 14h4l2-8 3 12 2-6h5" /></Svg>
  ),
  holopods: (p: IconProps) => (
    <Svg {...p}><path d="M3 8.5A2.5 2.5 0 0 1 5.5 6h8A2.5 2.5 0 0 1 16 8.5v7A2.5 2.5 0 0 1 13.5 18h-8A2.5 2.5 0 0 1 3 15.5v-7z" /><path d="M16 10.5 21 8v8l-5-2.5" /></Svg>
  ),
  apps: (p: IconProps) => (
    <Svg {...p}><path d="M12 3 4.5 7.5v9L12 21l7.5-4.5v-9L12 3z" /><path d="M12 12V21M4.5 7.5 12 12l7.5-4.5" /></Svg>
  ),
  models: (p: IconProps) => (
    <Svg {...p}><path d="M12 3 20 7.5v9L12 21 4 16.5v-9L12 3z" /></Svg>
  ),
  sync: (p: IconProps) => (
    <Svg {...p}><path d="M16 7h4v4" /><path d="M20 7a9 9 0 0 0-15.5 3" /><path d="M8 17H4v-4" /><path d="M4 17a9 9 0 0 0 15.5-3" /></Svg>
  ),
  data: (p: IconProps) => (
    <Svg {...p}><ellipse cx="12" cy="6" rx="8" ry="3" /><path d="M4 6v6c0 1.7 3.6 3 8 3s8-1.3 8-3V6" /><path d="M4 12v6c0 1.7 3.6 3 8 3s8-1.3 8-3v-6" /></Svg>
  ),
  compute: (p: IconProps) => (
    <Svg {...p}><rect x="3" y="4" width="18" height="12" rx="2" /><path d="M8 20h8M12 16v4" /></Svg>
  ),
  settings: (p: IconProps) => (
    <Svg {...p}><circle cx="12" cy="12" r="3" /><path d="M12 3.5v2.2M12 18.3V20.5M4.9 6.5l1.6 1.6M17.5 16l1.6 1.6M3.5 12h2.2M18.3 12H20.5M4.9 17.5l1.6-1.6M17.5 8.1l1.6-1.6" /></Svg>
  ),
  search: (p: IconProps) => (
    <Svg {...p}><circle cx="11" cy="11" r="6.5" /><path d="M16 16.5 20.5 21" /></Svg>
  ),
  sun: (p: IconProps) => (
    <Svg {...p}><circle cx="12" cy="12" r="4" /><path d="M12 3v2M12 19v2M4.2 4.2l1.4 1.4M18.4 18.4l1.4 1.4M3 12h2M19 12h2M4.2 19.8l1.4-1.4M18.4 5.6l1.4-1.4" /></Svg>
  ),
  moon: (p: IconProps) => (
    <Svg {...p}><path d="M18 14.5A7.5 7.5 0 1 1 9.5 6 6 6 0 0 0 18 14.5z" /></Svg>
  ),
  logout: (p: IconProps) => (
    <Svg {...p}><path d="M9 7V5.5A1.5 1.5 0 0 1 10.5 4h8A1.5 1.5 0 0 1 20 5.5v13A1.5 1.5 0 0 1 18.5 20h-8A1.5 1.5 0 0 1 9 18.5V17" /><path d="M13 12H4m0 0 3-3M4 12l3 3" /></Svg>
  ),
  plus: (p: IconProps) => (
    <Svg {...p}><path d="M12 5v14M5 12h14" /></Svg>
  ),
  menu: (p: IconProps) => (
    <Svg {...p}><path d="M4 7h16M4 12h16M4 17h16" /></Svg>
  ),
  close: (p: IconProps) => (
    <Svg {...p}><path d="M6 6l12 12M18 6 6 18" /></Svg>
  ),
  chevron: (p: IconProps) => (
    <Svg {...p}><path d="M9 6l6 6-6 6" /></Svg>
  ),
  chevronDown: (p: IconProps) => (
    <Svg {...p}><path d="M6 9l6 6 6-6" /></Svg>
  ),
  check: (p: IconProps) => (
    <Svg {...p}><path d="M5 12.5 9.5 17 19 7" /></Svg>
  ),
  download: (p: IconProps) => (
    <Svg {...p}><path d="M12 4v12m0 0-4-4m4 4 4-4M5 19h14" /></Svg>
  ),
  play: (p: IconProps) => (
    <Svg {...p}><path d="M7 5.5v13l12-6.5-12-6.5z" /></Svg>
  ),
  stop: (p: IconProps) => (
    <Svg {...p}><rect x="6" y="6" width="12" height="12" rx="1.5" /></Svg>
  ),
  copy: (p: IconProps) => (
    <Svg {...p}><rect x="8" y="8" width="12" height="12" rx="2" /><path d="M16 8V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h2" /></Svg>
  ),
  trash: (p: IconProps) => (
    <Svg {...p}><path d="M4 7h16M9 7V5h6v2M10 11v6M14 11v6M6 7l1 13h10l1-13" /></Svg>
  ),
  edit: (p: IconProps) => (
    <Svg {...p}><path d="M4 16.5V20h3.5L19 8.5 15.5 5 4 16.5z" /><path d="M13 6.5 17.5 11" /></Svg>
  ),
  inbox: (p: IconProps) => (
    <Svg {...p}><path d="M3 13 6 5h12l3 8v6H3v-6z" /><path d="M3 13h5.5l1.5 2h4l1.5-2H21" /></Svg>
  ),
  spark: (p: IconProps) => (
    <Svg {...p}><path d="M12 3v5M12 16v5M3 12h5M16 12h5M6.2 6.2l3.5 3.5M14.3 14.3l3.5 3.5M17.8 6.2l-3.5 3.5M9.7 14.3l-3.5 3.5" /></Svg>
  ),
  camera: (p: IconProps) => (
    <Svg {...p}><path d="M4 8h3l1.5-2h7L17 8h3a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1z" /><circle cx="12" cy="14" r="3.5" /></Svg>
  ),
  arrowRight: (p: IconProps) => (
    <Svg {...p}><path d="M5 12h14m0 0-5-5m5 5-5 5" /></Svg>
  ),
  external: (p: IconProps) => (
    <Svg {...p}><path d="M14 5h5v5M19 5 10 14" /><path d="M17 13.5V18a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h4.5" /></Svg>
  ),
  warning: (p: IconProps) => (
    <Svg {...p}><path d="M12 4 3 19h18L12 4z" /><path d="M12 9v5M12 16.5v.5" /></Svg>
  ),
  info: (p: IconProps) => (
    <Svg {...p}><circle cx="12" cy="12" r="9" /><path d="M12 11v6M12 8v.5" /></Svg>
  ),
  clock: (p: IconProps) => (
    <Svg {...p}><circle cx="12" cy="12" r="9" /><path d="M12 7v6l4 2" /></Svg>
  ),
  storage: (p: IconProps) => (
    <Svg {...p}><path d="M4 6h16v4H4zM4 14h16v4H4z" /><path d="M8 8v.01M8 16v.01" /></Svg>
  ),
  refresh: (p: IconProps) => (
    <Svg {...p}><path d="M20 12a8 8 0 1 1-2.3-5.6" /><path d="M20 5v5h-5" /></Svg>
  ),
  command: (p: IconProps) => (
    <Svg {...p}><path d="M9 9V6.5A2.5 2.5 0 1 0 6.5 9H9zm0 0h6M9 9v6m6-6v6m0-6h2.5A2.5 2.5 0 1 0 15 6.5V9zM9 15H6.5A2.5 2.5 0 1 0 9 17.5V15zm6 0h2.5A2.5 2.5 0 1 1 15 17.5V15z" /></Svg>
  ),
};

export type IconName = keyof typeof Icons;

export function Icon({ name, size = 16, ...rest }: IconProps & { name: IconName }) {
  const Cmp = Icons[name];
  return <Cmp size={size} {...rest} />;
}

export function BrandGlyph({ size = 16 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" aria-hidden>
      <path
        d="M1.5 8h3.2l1.9-5.2 2.1 10.4 1.8-5.2H14.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
